import { z } from 'zod';

import { ExternalLoanIdRecordId, ExternalLoanIdValue, LosId } from '../../BrandedIds';
import { ExternalLoanIdType } from '../../loan/ExternalLoanIdRecord';
import { zodTemporalInstant } from '../../Temporal';

export const ExportableExternalLoanId = z
  .object({
    loanId: LosId.describe('The loan this external ID belongs to.'),
    id: ExternalLoanIdRecordId.describe(
      'Stable internal record identifier. This is the database primary key for the external loan ID record, not the external ID value itself.',
    ),

    type: ExternalLoanIdType.describe('The kind of external identifier (e.g. MERS MIN, investor loan number).'),
    value: ExternalLoanIdValue.describe('The external identifier value.'),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,

    /**
     * commented out for now while we determine the right date representation for this field.
     */
    // startDate: zodTemporalPlainDate,
    /**
     * commented out for now while we determine the right date representation for this field.
     */
    // soldDate: zodTemporalPlainDate.optional(),
  })
  .meta({ title: 'ExternalLoanId' });
export type ExportableExternalLoanId = z.infer<typeof ExportableExternalLoanId>;
